import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export var res;
export const addDefectTodo = createAsyncThunk('addDefect', async (data) => {
    try {
        const res = await axios({
            method: "post",
            url: process.env.REACT_APP_API_URL + 'defect',
            data: {
                "name": data.defect,
                'category_status': data?.category,
                'remark': data?.remark,
                "status": data.status,
                "added_by": localStorage.getItem('userId')

            },
            headers: { "Content-Type": "application/json", "Authorization": 'Bearer ' + localStorage.getItem('token') }
        })
        return res

    } catch (error) {
        return error?.response
    }
})




